module.exports = __webpack_public_path__ + "media/images/icons/arrow-back-white-ecab037dafc8c42b310ac96e9dd26121.svg";